import { IApp } from '@/types/nuxt'
import { LogType } from '@tokyojob/frontend-core'

/**
 * Only applies for email accounts that try to create a duplicate account when their account is still unconfirmed.
 */
export default class ValidateUnconfirmedAccountUsecase implements BaseUsecase {
  app: IApp
  constructor(app: IApp) {
    this.app = app
  }

  async execute(uuid: string): Promise<void> {
    const { baseGateway, logService } = this.app
    try {
      baseGateway.auth.validateUnconfirmedAccount(uuid)
    } catch (error) {
      await logService.handle({ type: LogType.Error, error: error as Error })
    }
  }
}
